export default "__VITE_ASSET__fQcYNgII__"